import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';
import { fieldsetIdForSlot } from './schema';

/**
 * Editor do bloco "Publicações e Editais".
 *
 * O estado do item aberto é único e mora aqui — ver `OndeAtua/Edit.tsx`. Há
 * QUATRO listas de links (uma por aba), então o estado guarda o par
 * `{ aba, index }`: só a lista da aba em foco recebe o índice, as demais
 * recebem `-1` (fechado, mas ainda controlado).
 */
const Edit = (props) => {
  const { block, data, onSelectBlock, selected } = props;
  const [active, setActive] = React.useState({ aba: 0, index: -1 });

  const handleEditItem = React.useCallback(
    (aba: number, index: number) => {
      onSelectBlock?.(block);
      setActive({ aba, index });
      // A sidebar mostra as quatro abas empilhadas; sem rolar até a certa, o
      // item aberto pode ficar fora da área visível. Depois do próximo
      // paint, para o acordeão já estar com o item expandido.
      window.requestAnimationFrame(() => {
        document
          .getElementById(`blockform-fieldset-${fieldsetIdForSlot(aba)}`)
          ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    },
    [block, onSelectBlock],
  );

  const setActiveObject = React.useCallback(
    (aba: number, index: number) => setActive({ aba, index }),
    [],
  );

  return (
    <>
      <View {...props} data={data} onEditItem={handleEditItem} />

      <SidebarPortal selected={selected}>
        <Data
          {...props}
          activeObjects={{ [active.aba]: active.index }}
          setActiveObject={setActiveObject}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
